module.exports = __webpack_public_path__ + "static/media/18a-07_ST-2018-1918x1435mm-oleo-sobre-tela.02beba1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-07_ST-2018-1918x1435mm-oleo-sobre-tela.jpg
// module id = 225
// module chunks = 0